var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', [_vm._v("控制中心")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("帳號管理")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "\n        d-flex\n        flex-column flex-xl-row\n        align-items-start align-items-xl-center\n        justify-content-between\n        mb-4 mb-xl-2\n      "
  }, [_c('h4', {
    staticClass: "mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v("帳號管理")]), _c('div', {
    staticClass: "\n          d-flex\n          flex-column flex-xl-row\n          align-items-start align-items-xl-center\n        "
  }, [_vm.checkPermission([_vm.consts.EXPORT_STAFF_SPECIFIC_URI]) ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 mr-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.exportBindingQrcodes();
      }
    }
  }, [_vm._v(" 綁定 QRCode 匯出 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.EXPORT_STAFF_SPECIFIC_URI]) ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 mr-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.exportStaffWithBindingUrls();
      }
    }
  }, [_vm._v(" 綁定連結匯出 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.STAFF_LIST_VIEW]) ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 mr-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.exportStaff();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.displayTextStaff("staff_export", "匯出員工")) + " ")]) : _vm._e(), _vm.checkPermission([_vm.consts.STAFF_CREATE]) ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0",
    attrs: {
      "variant": "primary",
      "to": {
        name: 'StaffCreate'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(_vm._s(_vm.displayTextStaff("staff_create", "新增帳號")))]) : _vm._e(), _vm.$permissions.hasAny([_vm.consts.STAFF_IMPORT, _vm.consts.STAFF_CHANGE_PASSWORD]) ? _c('b-dropdown', {
    staticClass: "flex-shrink-0 ml-2",
    attrs: {
      "variant": "primary"
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('i', {
          staticClass: "fa fa-plus"
        }), _vm._v(" 批次上傳 ")];
      },
      proxy: true
    }], null, false, 941651847)
  }, [_vm.$permissions.has(_vm.consts.STAFF_IMPORT) ? [_c('b-dropdown-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-upload",
      modifiers: {
        "modal-upload": true
      }
    }]
  }, [_vm._v(_vm._s(_vm.displayTextStaff("staff_import", "批次上傳帳號")))]), _c('b-dropdown-item', {
    attrs: {
      "to": {
        name: 'StaffUploadAvatar'
      }
    }
  }, [_vm._v(_vm._s(_vm.displayTextStaff("staff_import_avatar", "批次上傳照片")))])] : _vm._e(), _vm.$permissions.has(_vm.consts.STAFF_CHANGE_PASSWORD) ? [_c('b-dropdown-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-password-upload",
      modifiers: {
        "modal-password-upload": true
      }
    }]
  }, [_vm._v(_vm._s(_vm.displayTextStaff("staff_import_password", "批次更新密碼")))])] : _vm._e()], 2) : _vm._e(), _c('b-input-group', {
    staticClass: "ml-0 ml-xl-4"
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": _vm.displayTextStaff('staff_search', '搜尋')
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handlePageResetWithoutReload.apply(null, arguments);
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.handlePageResetWithoutReload
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1), _c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-1-inner",
      modifiers: {
        "collapse-1-inner": true
      }
    }],
    staticClass: "flex-shrink-0 ml-0 ml-xl-1",
    attrs: {
      "variant": "link"
    }
  }, [_vm._v(" " + _vm._s(_vm.displayTextStaff("staff_advance_search", "進階搜尋"))), _c('i', {
    staticClass: "fa fa-chevron-down"
  })])], 1)]), _c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "collapse-1-inner"
    }
  }, [_c('div', {
    staticClass: "border p-2"
  }, [_c('b-form', {}, [_c('div', {
    staticClass: "d-flex flex-column flex-xl-row"
  }, [_vm.hiddenSearchField('has_branch') ? _c('b-form-group', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": _vm.displayTextStaff('staff_belong_branch', '所屬分店'),
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-sm": "",
      "content-cols-lg": "7"
    }
  }, [_vm.checkPermission([_vm.consts.STAFF_LIST_VIEW_NO_BRANCH]) ? _c('b-form-select', {
    staticClass: "mr-2",
    attrs: {
      "options": _vm.hasBranchOptions
    },
    on: {
      "change": _vm.handlePageResetWithoutReload
    },
    model: {
      value: _vm.query.has_branch,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "has_branch", $$v);
      },
      expression: "query.has_branch"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm.hiddenSearchField('has_line_id') ? _c('b-form-group', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": _vm.displayTextStaff('staff_search_line_id', 'Line ID'),
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-sm": "",
      "content-cols-lg": "7"
    }
  }, [_c('b-form-select', {
    staticClass: "mr-2",
    attrs: {
      "options": _vm.hasLineIdOptions
    },
    on: {
      "change": _vm.handlePageResetWithoutReload
    },
    model: {
      value: _vm.query.has_line_id,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "has_line_id", $$v);
      },
      expression: "query.has_line_id"
    }
  })], 1) : _vm._e()], 1), _c('div', {
    staticClass: "d-flex flex-column flex-xl-row"
  }, [_vm.hiddenSearchField('is_enbled') && _vm.hiddenSearchField('branch_id') ? _c('b-form-group', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": _vm.displayTextStaff('staff_search_status', '啟用狀態'),
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-sm": "",
      "content-cols-lg": "10"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_vm.hiddenSearchField('is_enbled') ? _c('b-form-select', {
    staticClass: "mr-2 d-inline-flex",
    attrs: {
      "options": _vm.isEnableOptions
    },
    on: {
      "change": _vm.handlePageResetWithoutReload
    },
    model: {
      value: _vm.query.is_enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "is_enabled", $$v);
      },
      expression: "query.is_enabled"
    }
  }) : _vm._e(), _vm.hiddenSearchField('branch_id') ? _c('b-form-select', {
    staticClass: "mr-2 d-inline-flex",
    attrs: {
      "options": _vm.checkPermission([_vm.consts.STAFF_LIST_VIEW_ALL_BRANCH, _vm.consts.BRANCH_LIST_VIEW]) ? _vm.allBranchOptions : _vm.branchOptions
    },
    on: {
      "change": function change($event) {
        return _vm.getStaffs(1);
      }
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function fn() {
        return [_c('b-form-select-option', {
          attrs: {
            "value": null
          }
        }, [_vm._v(_vm._s(_vm.displayTextStaff("staff_all_branch", "所有分店")))])];
      },
      proxy: true
    }], null, false, 3192391572),
    model: {
      value: _vm.query.branch_id,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "branch_id", $$v);
      },
      expression: "query.branch_id"
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm.hiddenSearchField('dept_name') ? _c('b-form-group', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": _vm.displayTextStaff('staff_search_dept_name', '部門'),
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-sm": "",
      "content-cols-lg": "7"
    }
  }, [_c('b-form-select', {
    staticClass: "mr-2 d-inline-flex",
    attrs: {
      "options": _vm.deptNameOptions
    },
    on: {
      "change": _vm.handlePageResetWithoutReload
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function fn() {
        return [_c('b-form-select-option', {
          attrs: {
            "value": null
          }
        }, [_vm._v(_vm._s(_vm.displayTextStaff("staff_all_dept_name", "所有部門")))])];
      },
      proxy: true
    }], null, false, 1167906756),
    model: {
      value: _vm.query.dept_name,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "dept_name", $$v);
      },
      expression: "query.dept_name"
    }
  })], 1) : _vm._e()], 1), _c('div', {
    staticClass: "d-flex flex-column flex-xl-row"
  }, [_vm.hiddenSearchField('is_locked') ? _c('b-form-group', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": _vm.displayTextStaff('staff_search_is_locked', '帳號狀態'),
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-sm": "",
      "content-cols-lg": "7"
    }
  }, [_c('b-form-select', {
    staticClass: "mr-2",
    attrs: {
      "options": _vm.isLockedOptions
    },
    on: {
      "change": _vm.handlePageResetWithoutReload
    },
    model: {
      value: _vm.query.is_locked,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "is_locked", $$v);
      },
      expression: "query.is_locked"
    }
  })], 1) : _vm._e(), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  })], 1), _c('div', {
    staticClass: "d-flex"
  }, [_vm.hiddenSearchField('roles') ? _c('b-form-group', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": _vm.displayTextStaff('staff_search_roles', '角色'),
      "label-cols-sm": "1",
      "content-cols-sm": "",
      "content-cols-lg": "11"
    }
  }, [_c('b-form-checkbox-group', {
    staticClass: "pt-1",
    attrs: {
      "options": _vm.roleOptions
    },
    on: {
      "change": _vm.handlePageResetWithoutReload
    },
    model: {
      value: _vm.query.roles,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "roles", $$v);
      },
      expression: "query.roles"
    }
  })], 1) : _vm._e()], 1), _c('b-form-group', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": _vm.displayTextStaff('staff_search_avatar', '頭像'),
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-sm": "",
      "content-cols-lg": "7"
    }
  }, [_c('b-form-radio-group', {
    model: {
      value: _vm.query.avatar,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "avatar", $$v);
      },
      expression: "query.avatar"
    }
  }, [_c('b-form-radio', {
    attrs: {
      "value": "has_avatar"
    }
  }, [_vm._v("有頭像")]), _c('b-form-radio', {
    attrs: {
      "value": "no_avatar"
    }
  }, [_vm._v("無頭像")]), _c('b-form-radio', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("不限")])], 1)], 1)], 1)], 1)]), _c('b-card-text', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.staffs,
      "fields": _vm.fields,
      "show-empty": ""
    },
    scopedSlots: _vm._u([{
      key: "cell(avatar_url)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "d-flex align-items-center justify-content-center"
        }, [_c('b-avatar', {
          attrs: {
            "src": data.item.avatar_url,
            "variant": "secondary",
            "size": "2rem"
          }
        })], 1)];
      }
    }, {
      key: "cell(branch_name)",
      fn: function fn(data) {
        return [_c('span', {
          staticClass: "branch-name-cell"
        }, [_vm._v(_vm._s(data.item.branch_name))])];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_c('b-dropdown', {
          attrs: {
            "id": "ddown23",
            "variant": "secondary"
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('i', {
          staticClass: "mdi mdi-menu"
        })]), _c('b-dropdown-item', {
          attrs: {
            "to": {
              name: 'StaffView',
              params: {
                staff_id: data.item.id
              }
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.displayTextStaff("staff_view_action", "查看")) + " ")]), _vm.checkPermission([_vm.consts.STAFF_MODIFY]) ? _c('b-dropdown-item', {
          attrs: {
            "to": {
              name: 'StaffForm',
              params: {
                staff_id: data.item.id
              }
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.displayTextStaff("staff_edit_action", "編輯")) + " ")]) : _vm._e(), _vm.checkPermission([_vm.consts.STAFF_BRANCH_MODIFY]) ? _c('b-dropdown-item', {
          attrs: {
            "to": {
              name: 'StaffSetBranch',
              params: {
                staff_id: data.item.id
              }
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.displayTextStaff("staff_set_branch_action", "設定所屬分店")) + " ")]) : _vm._e(), _vm.checkPermission([_vm.consts.STAFF_CUSTOMER_VIEW]) ? _c('b-dropdown-item', {
          attrs: {
            "to": {
              name: 'StaffCustomerList',
              params: {
                staff_id: data.item.id
              }
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.displayTextStaff("staff_set_customer_action", "設定客戶")) + " ")]) : _vm._e(), _vm.checkPermission([_vm.consts.STAFF_ROLE_MODIFY]) ? _c('b-dropdown-item', {
          attrs: {
            "to": {
              name: 'StaffSetRole',
              params: {
                staff_id: data.item.id
              }
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.displayTextStaff("staff_set_role_action", "設定角色")) + " ")]) : _vm._e(), _vm.checkPermission([_vm.consts.STAFF_CHANGE_PASSWORD]) ? _c('b-dropdown-item', {
          attrs: {
            "to": {
              name: 'StaffChangePassword',
              params: {
                staff_id: data.item.id
              }
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.displayTextStaff("staff_change_password_action", "變更密碼")) + " ")]) : _vm._e(), _vm.checkPermission([_vm.consts.STAFF_DELETE]) && data.item.id != _vm.user.id ? _c('b-dropdown-item', {
          on: {
            "click": function click($event) {
              return _vm.deleteStaff(data.item);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.displayTextStaff("staff_delete_action", "刪除")) + " ")]) : _vm._e()], 2)];
      }
    }, {
      key: "empty",
      fn: function fn() {
        return [_c('div', {
          staticClass: "text-center text-muted"
        }, [_c('p', [_vm._v("查無資料")])])];
      },
      proxy: true
    }])
  })], 1)], 1)]), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.totalRows,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "modal-upload",
      "title": _vm.displayTextStaff('staff_import', '批次上傳')
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var cancel = _ref.cancel;
        return [_c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-primary"
          },
          on: {
            "click": function click($event) {
              _vm.getSampleExcelFile(_vm.getModuleConfig('staff', 'sample_file.staff_import_xls'), '/excel/staff_list.xlsx');
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-file-text"
        }), _vm._v(_vm._s(_vm.displayTextStaff("staff_import_download_text", "下載範例檔案")))]), _c('b-button', {
          staticClass: "float-right",
          attrs: {
            "variant": "outline-danger",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.displayTextStaff("staff_import_close", "關閉")) + " ")])];
      }
    }])
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoadingUpload
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "flex-shrink-0 mr-2 mb-0"
  }, [_vm._v(_vm._s(_vm.displayTextStaff("staff_import_text", "請上傳帳號 Excel 檔案")))]), _c('b-form-file', {
    attrs: {
      "plain": "",
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽"
    },
    on: {
      "input": _vm.uploadStaff
    }
  })], 1)])], 1), _c('b-modal', {
    attrs: {
      "id": "modal-password-upload",
      "title": _vm.displayTextStaff('staff_import', '批次更新密碼')
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref2) {
        var cancel = _ref2.cancel;
        return [_c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-primary"
          },
          on: {
            "click": function click($event) {
              _vm.getSampleExcelFile(_vm.getModuleConfig('staff', 'sample_file.staff_password_import_xls'), '/excel/staff_password_list.xlsx');
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-file-text"
        }), _vm._v(" " + _vm._s(_vm.displayTextStaff("staff_import_download_text", "下載範例檔案")) + " ")]), _c('b-button', {
          staticClass: "float-right",
          attrs: {
            "variant": "outline-danger",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.displayTextStaff("staff_password_import_close", "關閉")) + " ")])];
      }
    }])
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoadingUpload
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "flex-shrink-0 mr-2 mb-0"
  }, [_vm._v(_vm._s(_vm.displayTextStaff("staff_password_import_text", "請上傳密碼 Excel 檔案")))]), _c('b-form-file', {
    attrs: {
      "plain": "",
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽"
    },
    on: {
      "input": _vm.uploadPassword
    }
  })], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }